// src/hooks/useLoading.ts
import React from 'react';
import LoadingContext from './loading.context';

const useLoading = () => {
    const {setLoading} = React.useContext(LoadingContext);

    const showLoading = (content?: string, backgroundColor?: string, mask?: boolean) => {
        setLoading({show: true, content, backgroundColor,mask});
    };

    const hideLoading = () => {
        setLoading({show: false});
    };

    return {showLoading, hideLoading};
};

export default useLoading;